import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login.vue'
import index from '@/page/index.vue'
import aboutUs from '@/page/aboutUs.vue'
import product from '@/page/product.vue'
import news from '@/page/news.vue'
import joinUs from '@/page/joinUs.vue'
import deliver from '@/page/deliver.vue'
import resume from '@/page/resume.vue'
import investor from '@/page/investor.vue'
import ourteam from '@/page/team/ourteam.vue'
import teamparticulars from '@/page/team/teamparticulars.vue'
import patienlist from '@/page/patien/patienlist.vue'
import patienparticulars from '@/page/patien/patienparticulars.vue'
import Msgdetails from '@/page/patien/Msgdetails.vue'
import agreement from '@/page/patien/agreement.vue'
import goodsdetails from '@/page/product/goodsdetails.vue'
import lungcancer from '@/page/product/lungcancer.vue'
import lungcancer1 from '@/page/product/lungcancer1.vue'
import lungcancer6 from '@/page/product/lungcancer6.vue'
import lingchuang from '@/page/product/lingchuang.vue'
import announcement from '@/page/investor/announcement.vue'
import financial from '@/page/investor/financial.vue'
import financiaNews from '@/page/investor/financiaNews.vue'
import InvestoLog from '@/page/investor/InvestoLog.vue'
import activity from '@/page/investor/activity.vue'
import govern from '@/page/investor/govern.vue'
import analyst from '@/page/investor/analyst.vue'
import question from '@/page/investor/question.vue'
import contact from '@/page/investor/contact.vue'
import reports from '@/page/investor/reports.vue'
import ContactUs from '@/page/ContactUs.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/index*',
      name: 'index',
      component: index
    },
    {
      path: '/aboutUs*',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/product*',
      name: 'product',
      component: product
    },
    {
      path: '/news*',
      name: 'news',
      component: news
    },
    {
      path: '/joinUs*',
      name: 'joinUs',
      component: joinUs
    },
    {
      path: '/deliver*',
      name: 'deliver',
      component: deliver
    },
    {
      path: '/resume*',
      name: 'resume',
      component: resume
    },
    {
      path: '/investor*',
      name: 'investor',
      component: investor
    },
    {
      path: '/ourteam*',
      name: 'ourteam',
      component: ourteam
    },
    {
      path: '/teamparticulars*',
      name: 'teamparticulars',
      component: teamparticulars
    },
    {
      path: '/patienlist*',
      name: 'patienlist',
      component: patienlist
    },
    {
      path: '/patienparticulars*',
      name: 'patienparticulars',
      component: patienparticulars
    },
    {
      path: '/agreement*',
      name: 'agreement',
      component: agreement
    },
    {
      path: '/goodsdetails*',
      name: 'goodsdetails',
      component: goodsdetails
    },
    {
      path: '/lungcancer',
      name: 'lungcancer',
      component: lungcancer
    },
    {
      path: '/lungcancer1',
      name: 'lungcancer1',
      component: lungcancer1
    },
    {
      path: '/lungcancer6',
      name: 'lungcancer6',
      component: lungcancer6
    },
    {
      path: '/lingchuang*',
      name: 'lingchuang',
      component: lingchuang
    },
    {
      path: '/announcement*',
      name: 'announcement',
      component: announcement
    },
    {
      path: '/financial*',
      name: 'financial',
      component: financial
    },
    {
      path: '/financiaNews*',
      name: 'financiaNews',
      component: financiaNews
    },
    {
      path: '/InvestoLog*',
      name: 'InvestoLog',
      component: InvestoLog
    },
    {
      path: '/activity*',
      name: 'activity',
      component: activity
    },
    {
      path: '/govern*',
      name: 'govern',
      component: govern
    },
    {
      path: '/analyst*',
      name: 'analyst',
      component: analyst
    },
    {
      path: '/question*',
      name: 'question',
      component: question
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/reports*',
      name: 'reports',
      component: reports
    },
    {
      path: '/Msgdetails*',
      name: 'Msgdetails',
      component: Msgdetails
    },
  ],
  // mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js